// Single source of truth for "where is this build running" — App.tsx and the
// telemetry module both need it, so it lives here instead of being defined
// twice. App.tsx re-exports isNativeQuestWrapper/isPwaLaunchContext from this
// module rather than keeping its own copies.

export function isNativeQuestWrapper(): boolean {
  const launchSource = new URLSearchParams(window.location.search).get(
    "sq_native",
  );
  return launchSource === "1" || "getDigitalGoodsService" in window;
}

export function isPwaLaunchContext(): boolean {
  if ("getDigitalGoodsService" in window) return true;
  return ["standalone", "fullscreen"].some(
    (mode) => window.matchMedia(`(display-mode: ${mode})`).matches,
  );
}

export type TelemetryPlatform =
  | "quest-twa"
  | "quest-pwa"
  | "quest-browser"
  | "desktop"
  | "other";

export function detectPlatform(): TelemetryPlatform {
  const isQuest = /OculusBrowser|Quest/i.test(navigator.userAgent);
  if (isNativeQuestWrapper()) return "quest-twa";
  if (isQuest) return isPwaLaunchContext() ? "quest-pwa" : "quest-browser";
  if (isPwaLaunchContext()) return "other"; // installed PWA on a non-Quest device — rare, not worth its own bucket
  return "desktop";
}
